var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExitSimple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 2.34326C3.08662 1.60035 3.96853 1.01105 4.93914 0.608992C5.90974 0.206936 6.95003 -1.11523e-07 8.00061 0C9.05118 1.11523e-07 10.0915 0.206936 11.0621 0.608993C12.0327 1.01105 12.9146 1.60035 13.6575 2.34326C14.4003 3.08616 14.9896 3.96812 15.3916 4.93877C15.7937 5.90942 16.0006 6.94975 16.0006 8.00038C16.0006 9.051 15.7937 10.0913 15.3916 11.062C14.9896 12.0326 14.4003 12.9146 13.6575 13.6575L2.34375 2.34326Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47452 12.5261C5.97387 15.0255 10.0261 15.0255 12.5255 12.5261C15.0248 10.0266 15.0248 5.97415 12.5255 3.47468C10.0261 0.975207 5.97387 0.975207 3.47452 3.47468C0.975161 5.97415 0.975161 10.0266 3.47452 12.5261ZM2.34315 13.6575C5.46734 16.7818 10.5327 16.7818 13.6569 13.6575C16.781 10.5332 16.781 5.4676 13.6569 2.34326C10.5327 -0.781086 5.46734 -0.781086 2.34315 2.34326C-0.781049 5.4676 -0.781049 10.5332 2.34315 13.6575Z",
    fill: "#676767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4524 5.54899C10.7648 5.86142 10.7648 6.36798 10.4524 6.68041L6.68117 10.4518C6.36875 10.7643 5.86222 10.7643 5.5498 10.4518C5.23738 10.1394 5.23738 9.63284 5.5498 9.3204L9.32103 5.54899C9.63345 5.23655 10.14 5.23655 10.4524 5.54899Z",
    fill: "#676767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4519 10.4517C10.1395 10.7641 9.63294 10.7641 9.32052 10.4517L5.54929 6.68028C5.23687 6.36785 5.23687 5.86129 5.54929 5.54886C5.86171 5.23642 6.36824 5.23643 6.68066 5.54886L10.4519 9.32027C10.7643 9.63271 10.7643 10.1393 10.4519 10.4517Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitSimple);
export default __webpack_public_path__ + "static/media/ic-exit-simple.a016968657ab6b1f3cbfcf027d15118e.svg";
export { ForwardRef as ReactComponent };